import { recordSentry } from "utils/recordSentry";

export interface ImageProcessingResult {
	compressedBucket: string;
	compressionBucketSuccess: boolean;
	compressedKey: string;
	message: string;
	operationSuccess: boolean;
	sourceBucket: string;
	sourceBucketSuccess: boolean;
	sourceKey: string;
}

export function handleToolboxResponse(response: ImageProcessingResult): string {
	// In the 401/403 case, only message will be defined;
	const { compressedBucket, compressionBucketSuccess, compressedKey, message, operationSuccess, sourceBucket, sourceBucketSuccess, sourceKey } = response;
	if (message === "Success") {
		return compressedKey;
	} else {
		// Both the 400 and 500 should make it to the normal process, but an error happens in there. Now we should just figure out what
		recordSentry({
			error: response,
			msg: message,
			additionalData: {
				compressedBucket,
				compressionBucketSuccess,
				operationSuccess,
				sourceBucketSuccess,
				sourceKey,
				sourceBucket,
			},
		});
	}
	return "";
}
